











































































import { getBranchName } from "@/data/models/Branch";
import ClientPanel from "@/data/models/ClientPanel";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { updateClientPanelsBySerialNumber } from "@/data/repository/ClientPanelRepository";
import { findBranch, getBranchesOfClient, getVehicleManagementAccess } from "@/data/repository/ClientRepository";
import { updateDevicesById } from "@/data/repository/GenericDeviceRepository";
import { getBranchesVisibleToActiveUser } from "@/data/repository/UserRepository";
import { filterOutUndefined } from "@/utils/Utils";
import { firestore } from "firebase";
import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import BaseDialogComponent from '../common/BaseDialog.vue';
import ConfirmationDialogComponent from '../common/ConfirmationDialog.vue';
import DatePickerCompoment from '../common/DatePicker.vue';
import PickerDialogComponent from '../common/PickerDialog.vue';

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "date-picker": DatePickerCompoment,
    picker: PickerDialogComponent,
  },
})

export default class MultiDevicesDetailsDialog extends Vue {
  @Prop()
  selectedClientPanels!: ClientPanel[];

  @Prop()
  selectedDeviceOverviews!: DeviceOverview[];

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;
  
  title = "";
  
  availabilityOptions = [0, 1];

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  showingErrorSnackbar = false;
  errorSnackbarText = "";

  isLoading = false;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  acquisitionDate: firestore.Timestamp | null | undefined = null;
  isAvailableValue: number | null = null;
  homeLocation: string | null | undefined = null;
  branch: string | null | undefined = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialDetails: any = {};

  cancelButtonText = this.$t("common.abort").toString();
  closeButtonText = this.$t("common.close").toString();
  saveButtonText = this.$t("common.save").toString();

  @Watch("hasDetailsEdited")
  onHasDetailsEditedChanged() {
    this.baseDialogComponent.negativeButtonText = this.calculateNegativeButtonText();
  }

  get branchFormatter() {
    return (branchId: string) => {
      return getBranchName(findBranch(branchId));
    };
  }

  get columnSize() {
    if (this.showBranchSelector) {
      return this.isVehicleManagementEnabled ? 4 : 3;
    }

    return 6;
  }

  get branchOptions() {
    return getBranchesVisibleToActiveUser().map((branch) => branch.id);
  }

  get hasDetailsEdited() {
    return this.acquisitionDate !== this.initialDetails.acquisitionDate ||
      this.isAvailableValue !== this.initialDetails.isAvailableValue ||
      this.homeLocation !== this.initialDetails.homeLocation ||
      this.branch !== this.initialDetails.branch;
  }

  get showBranchSelector() {
    return this.branchOptions.length > 0;
  }

  formatAvailabilityOptions(value: number) {
    return this.$t(`allDevices.${value === 0 ? "available" : "notAvailable"}`).toString();
  }

  getBranchNumberString(branchId: string | null | undefined) {
    if (!branchId) {
      return null;
    }

    const branches = getBranchesOfClient();
    const deviceBranch = branches.filter(branch => branchId === branch.id.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].branchNumber.toString();
    }

    return null;
  }

  restoreIntialValues() {
    this.acquisitionDate = null;
    this.isAvailableValue = null;
    this.homeLocation = null;
    this.branch = null;

    this.initialDetails = {
      acquisitionDate: this.acquisitionDate,
      isAvailableValue: this.isAvailableValue,
      homeLocation: this.homeLocation,
      branch: this.branch
    }
  }

  get isVehicleManagementEnabled() {
    return getVehicleManagementAccess();
  }

  async onSave() {
    this.isLoading = true;

    const update = filterOutUndefined({
      acquisitionDate: this.acquisitionDate !== this.initialDetails.acquisitionDate ? this.acquisitionDate : undefined,
      availability: this.isAvailableValue !== this.initialDetails.isAvailableValue ? this.isAvailableValue : undefined,
      homeLocation: this.homeLocation !== this.initialDetails.homeLocation ? this.getBranchNumberString(this.homeLocation) : undefined,
      branch: this.isVehicleManagementEnabled ? undefined : this.branch !== this.initialDetails.branch ? this.getBranchNumberString(this.branch) : undefined
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedClientPanels = new Map<string, any>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedOtherDevices = new Map<string, any>();

    this.selectedClientPanels.forEach((clientPanel) => {
      updatedClientPanels.set(
        clientPanel.serialNumber,
        update
      )
    });

    this.selectedDeviceOverviews.forEach((deviceOverview) => {
      updatedOtherDevices.set(
        deviceOverview.id,
        update
      )
    });

    const isUpdateClientPanelsSuccessful = this.selectedClientPanels.length > 0 ? await updateClientPanelsBySerialNumber(updatedClientPanels) : true;
    const isUpdateOtherDevicesSuccessful = this.selectedDeviceOverviews.length > 0 ? await updateDevicesById(updatedOtherDevices) : true;
  
    if (isUpdateClientPanelsSuccessful && isUpdateOtherDevicesSuccessful) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      this.baseDialogComponent.isShowing = false;
      
      this.$emit("toggleSelectionMode");
    }
    else {
      this.showingErrorSnackbar = true;
      this.errorSnackbarText = this.$t("common.changesNotSaved").toString();
    }

    this.isLoading = false;
  }

  async onCancel() {
    this.restoreIntialValues();
    this.baseDialogComponent.isShowing = false;
  }

  async show() {
    this.title = this.$t("allDevices.multiDevicesEditDialog.title").toString();

    const positiveButtonText = this.saveButtonText;
    const negativeButtonText = this.calculateNegativeButtonText();


    this.baseDialogComponent.show({
      title: this.title,
      positiveButtonText: positiveButtonText,
      negativeButtonText: negativeButtonText,
      closeOnSave: true,
      maxWidth: 600,
    });

    this.restoreIntialValues();

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  calculateNegativeButtonText() {
    return !this.hasDetailsEdited
      ? this.closeButtonText
      : this.cancelButtonText;
  }
}
